export function getMountId(): string {
  return crypto.randomUUID();
}

export function getTabId(): string {
  const key = 'tab_id';

  try {
    const existing = sessionStorage.getItem(key);

    if (existing) return existing;

    const id = getMountId();

    sessionStorage.setItem(key, id);

    return id;
  } catch (ex) {
    console.error('error set tab id', ex);

    return getMountId();
  }
}
